import { useState } from 'react';
import { useParams, useOutletContext } from "react-router-dom";
import { Button, FormGroup, Input, Label } from 'reactstrap';

import {translations} from './../../i18/translations.js';

const ForgotPwd = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const {lang, showAlert} = useOutletContext();
    const {token} = useParams();

    const [pwd, setPwd] = useState('');
    const [pwdRe, setPwdRe] = useState('');

    const handlePwdChange = (e) => {
        setPwd(e.target.value);
    };
    const handlePwdReChange = (e) => {
        setPwdRe(e.target.value);
    };

    const savePwd = async () => {
        try {
            if (!pwd || pwd.length < 5) {
                showAlert({type: 'alert-danger', message: 'error_validation_pwd_length'});
                return;
            }
            if (!pwdRe || pwd !== pwdRe) {
                showAlert({type: 'alert-danger', message: 'forgot_pwd_err_mismatch'});
                return;
            }
            const payload = {
                forgotpwd: {
                    token: token,
                    pwd: pwd
                }
            };
            const response = await fetch(`${API_URL}/common/change_forgot_pwd.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            if (data.alert) {
                showAlert(data.alert);
            } else {
                showAlert({type: 'alert-danger', message: 'Unknown error occurred'});
            }
        } catch (error) {
            console.error("Error saving forgot password:", error);
            showAlert({type: 'alert-danger', message: 'forgot_pwd_err_server'});
        }
    };

    return (
            <>
            <h1 className="mbkegy-content">{translations[lang].forgot_pwd}</h1>
            <form>        
                <FormGroup floating>
                    <Input
                        id="pwd"
                        type="password"
                        value={pwd}
                        autoComplete="new-password"
                        onChange={handlePwdChange}/>
                    <Label for="forgotPwdEmail">{translations[lang].forgot_pwd_new_pwd}</Label>
                </FormGroup>
                <FormGroup floating>
                    <Input
                        id="pwdre"
                        type="password"
                        autoComplete="new-password"
                        value={pwdRe}
                        onChange={handlePwdReChange}/>
                    <Label for="forgotPwdEmail">{translations[lang].forgot_pwd_new_pwd_re}</Label>
                </FormGroup>
            </form>
            <Button color="primary" onClick={savePwd}>
                {translations[lang].forgot_pwd_save_pwd}
            </Button>
            
            </>
            );
};

export default ForgotPwd;